import React from "react";
import WebsiteStructure from "./WebsiteStructure";

const App = () => {
  return <WebsiteStructure />;
};

export default App;
